var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('b-container',[_c('h1',[_vm._v("SysJudge")]),_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("自動化線上解題系統")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }